import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonRow,
    IonCol,
    IonButton,
    IonItem,
    IonThumbnail,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonCheckbox,
    IonAlert,
    IonAccordion,
    IonBadge,
    IonAccordionGroup,
    IonPopover,
    IonDatetime,
    IonSearchbar,
    IonList
} from '@ionic/react';
import { cash, homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline, createOutline, trashOutline, add, closeOutline, barcode, calendar, search, funnel } from 'ionicons/icons';
import PosActions from '../../../actions/PosActions';
import ExpenseActions from '../../../actions/ExpenseActions';
import { getDominio, getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { types } from 'util';
import Moment from 'react-moment';
import moment from 'moment';
import { DebounceInput } from 'react-debounce-input';
interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    ModalShow: any;
    fields: any;
    datalogin: any;
    pages: any;
    pageSize: any;
    total_rows: any;
    searchText: any;
    current_count_data: any;
    alertDestroy: any;

    dataDB: any;
    data_pagin_DB: any;

    currencyprimary: any;
    data_default: any;
    formErrors: any;
    categoriesDB: any;
    sub_categories: any;
    slcategoriessub_selected: any;

    isOpenTransactionDate: any;
    usersDB: any;
    filter_categories: any;
    filter_sub_categories: any;

    isOpenDateStart: any;
    isOpenDateEnd: any;
    DateStart: any;
    DateEnd: any;
    isOpenModalFilterDate: any;
}

const options2: any = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

class listGastos extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    ModalcreateEdit: React.RefObject<HTMLIonModalElement>;

    constructor(props: any) {
        super(props)
        this.ModalcreateEdit = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.state = {
            ModalShow: false,
            fields: {
                id: null
            },
            datalogin: {},
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false,
            dataDB: [],
            data_pagin_DB: [],

            currencyprimary: props.currencyprimary,
            data_default: [],
            formErrors: {},

            categoriesDB: [],
            sub_categories: [],
            slcategoriessub_selected: [],

            isOpenTransactionDate: false,
            usersDB: [],
            filter_categories: null,
            filter_sub_categories: null,

            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false
        }
    }

    componentDidMount() {
        this.setState({
            ModalShow: false,
            fields: {
                id: null,
                location_id: null,
                expense_category_id: null,
                expense_sub_category_id: null,
                transaction_date: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
                expense_for: null,
                final_total: 0,
                additional_notes: null
            },
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false,
            sub_categories: [],

            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }


    UNSAFE_componentWillReceiveProps(nextProps: any) {

        this.setState({
            dataDB: nextProps.data.expensesDB && nextProps.data.expensesDB ? nextProps.data.expensesDB : [],
            data_pagin_DB: nextProps.data.data_pagin_expensesDB && nextProps.data.data_pagin_expensesDB ? nextProps.data.data_pagin_expensesDB : [],
            pages: nextProps.data.expensesDB && nextProps.data.expensesDB.pages ? nextProps.data.expensesDB.pages : 0,
            total_rows: nextProps.data.expensesDB && nextProps.data.expensesDB.total_rows ? nextProps.data.expensesDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_expensesDB ? nextProps.data.data_pagin_expensesDB.length : 0,

            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            data_default: nextProps.data.data_default,
            categoriesDB: nextProps.data.data_default && nextProps.data.data_default.categories_expenses ? nextProps.data.data_default.categories_expenses : [],
            usersDB: nextProps.data.data_default && nextProps.data.data_default.users ? nextProps.data.data_default.users : []
        });

        if (nextProps.data.view_active == "dashboard_gastos/expenses") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }


    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_gastos',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_gastos/list_gastos',
            filter_categories: this.state.filter_categories,
            filter_sub_categories: this.state.filter_sub_categories,
            searchText: this.state.searchText,

            start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
            end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
        }, "api/list_gastos");
    }

    render_data(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-6 size='6'>
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.ref_no}</strong></label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={calendar} /> </strong> {row.transaction_date}</label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={cash} /></strong>
                            <strong>{_numberFormat.format(row.final_total).replace("$", this.state.currencyprimary)}</strong>
                            {' '}
                            {row.payment_status == 'paid' ?
                                <IonBadge color={"success"} style={{ color: '#ffffff' }}> {'Pagada'}</IonBadge>
                                : row.payment_status == 'partial' ?
                                    <IonBadge color={"info"} style={{ color: '#ffffff' }}> {'Parcial'} </IonBadge>
                                    : <IonBadge color={"danger"} style={{ color: '#ffffff' }}>{'Crédito'}</IonBadge>
                            }
                        </label>
                    </IonCol>
                    <IonCol col-6 size='6'>
                        {
                            row.parent_name ? (
                                <label className='text-sm font-medium text-g60'><IonBadge color={"primary"}>{row.parent_name}</IonBadge></label>
                            ) : null
                        }
                        {
                            row.sub_parent_name ? (
                                <>
                                    <br /><label className='text-sm font-medium text-g60'> -- <IonBadge color={"rosado"}>{row.sub_parent_name}</IonBadge></label>
                                </>
                            ) : null
                        }
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.openModal(row)} color={'primary'}
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'} onClick={
                            e => this.setState({ alertDestroy: true, fields: row })
                        }>
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    openModal(row: any) {
        let fields = {
            id: row && row.id ? row.id : null,
            location_id: row && row.location_id ? row.location_id : null,
            expense_category_id: row && row.expense_category_id ? row.expense_category_id : null,
            expense_sub_category_id: row && row.expense_sub_category_id ? row.expense_sub_category_id : null,
            transaction_date: row && row.transaction_date ? moment(row.transaction_date, "DD-MM-YYYY hh:mm").format("YYYY-MM-DD") : moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            expense_for: row && row.expense_for ? row.expense_for : null,
            final_total: row && row.final_total ? row.final_total : 0,
            additional_notes: null
        };

        let slcategoriessub_selected = [];

        if (fields.expense_category_id && Number(fields.expense_category_id) > 0) {
            slcategoriessub_selected = this.state.categoriesDB.filter((value: any) => value.parent_id == fields.expense_category_id);
            this.setState({ slcategoriessub_selected });
        }
        this.setState({
            ModalShow: true,
            fields: fields,
            slcategoriessub_selected: slcategoriessub_selected,
            formErrors: {},
        });
    }

    dismissModalUnits() {
        this.setState({
            ModalShow: false,
            fields: {
                id: null
            }
        });
    }

    SaveDataPost() {
        let fields = this.state.fields;
        let error = false;
        let formErrors: any = {};
        if (this.state.fields && (this.state.fields.final_total == "" || this.state.fields.final_total == null || this.state.fields.final_total == 0)) { formErrors['final_total'] = "*Campo Requerido y mayor a cero"; error = true };
        if (this.state.fields && (this.state.fields.location_id == "" || this.state.fields.location_id == null)) { formErrors['location_id'] = "*Campo Requerido y mayor a cero"; error = true };
        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fields.id) {
                this.props.post_({
                    typeOption: 'updateDataExpense',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fields: this.state.fields,
                    view_active: 'dashboard_gastos/expenses'
                }, "api/updateDataExpense");
            } else {
                this.props.post_({
                    typeOption: 'saveDataExpense',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fields: this.state.fields,
                    view_active: 'dashboard_gastos/expenses'
                }, "api/saveDataExpense");
            }
            this.setState({
                ModalShow: false,
            });
        }



    }

    handleChangeFields(event: any) {
        let fields = this.state.fields;

        if (event.target.name == "expense_category_id") {
            let slcategoriessub_selected: any = [];
            if (event.target.value == null) {
                fields[event.target.name] = event.target.value;
                fields["expense_sub_category_id"] = null;
                slcategoriessub_selected = [];
            } else {
                fields[event.target.name] = event.target.value;
                fields["expense_sub_category_id"] = null;
                slcategoriessub_selected = this.state.categoriesDB.filter((value: any) => value.parent_id == event.target.value);
            }
            this.setState({ fields, slcategoriessub_selected });

        } else {
            fields[event.target.name] = event.target.value;
            this.setState({ fields });
        }

    }

    handleFocus(event: any) {
        event.target.select();
    }

    handleChangeState(event: any) {

        let categories: any = this.state.categoriesDB;
        let sub_categories: any = this.state.categoriesDB;
        let filter_sub_categories = this.state.filter_sub_categories;
        if (event.target.name == 'filter_categories') {
            if (event.target.value == null) {
                sub_categories = [];
                filter_sub_categories = null;
            } else {
                sub_categories = categories.filter((value: any) => value.parent_id == event.target.value);
            }
        } else if (event.target.name == 'filter_sub_categories') {
            sub_categories = categories.filter((value: any) => value.parent_id == this.state.filter_categories);
        }

        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,

            pages: 0,
            pageSize: 10,
            sub_categories: sub_categories,
            filter_sub_categories: filter_sub_categories
        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(7, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false,
            pages: 0,
            pageSize: 10,
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);
    }
    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDataexpense',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fields: this.state.fields,
            view_active: 'dashboard_gastos/expenses'
        }, "api/destroyDataexpense");
        this.setState({
            alertDestroy: false
        });
    }
    render() {
        const { alertDestroy, isOpenDateStart, isOpenDateEnd, DateStart, DateEnd, isOpenModalFilterDate, searchText, sub_categories, filter_categories, filter_sub_categories, usersDB, isOpenTransactionDate, data_pagin_DB, fields, ModalShow, data_default, formErrors, categoriesDB, slcategoriessub_selected } = this.state;
        let data_render_data = [];
        if (data_pagin_DB && data_pagin_DB.length > 0) {
            data_render_data = [];
            data_render_data = data_pagin_DB.map((val: any, key: any) =>
                this.render_data(val, key)
            );
        };

        return (
            <>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    message={'¿Desea eliminar el Gasto ' + (fields && fields.ref_no ? ('con código ' + fields.ref_no) : '') + '?'}
                    buttons={[
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonPage>
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonButtons slot="start">
                                <IonBackButton defaultHref="/home" text={""} />
                            </IonButtons>
                            <IonTitle>Lista de Gastos</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent fullscreen scrollEvents={true} style={{ boderRadius: '10px' }}>
                        <IonRow>
                            <IonCol col-6 size='6'>
                                <label>Categoria: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_categories', value: e.value } })}
                                    placeholder="Categoria"
                                    name='filter_categories'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(categoriesDB && categoriesDB
                                            .filter((value: any) => value.parent_id == null)
                                            .map((value: any) => ({ label: value.name, value: value.id }))
                                        )
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_categories ?
                                        categoriesDB && categoriesDB.length > 0 ?
                                            {
                                                label: categoriesDB.filter((item: any) => item.id == filter_categories)[0].name, value: categoriesDB.filter((item: any) => item.id == filter_categories)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol col-6 size='6'>
                                <label>Sub Categoria: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'filter_sub_categories', value: e.value } })}
                                    placeholder="Sub Categoria"
                                    name='filter_sub_categories'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(Array.isArray(sub_categories)
                                            ? sub_categories.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                            : [])
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={filter_sub_categories && filter_sub_categories != null && filter_sub_categories != '' ?
                                        sub_categories && sub_categories.length > 0 ?
                                            {
                                                label: sub_categories.filter((item: any) => item.id == filter_sub_categories)[0].name, value: sub_categories.filter((item: any) => item.id == filter_sub_categories)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol col-12 size='12' style={{ textAlign: "center", display: "none" }}>
                                <div style={{ display: "none" }}>
                                    <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                                </div>

                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({
                                            isOpenDateStart: true,
                                            pages: 0,
                                            pageSize: 10,
                                        });
                                    }}
                                >
                                    Inicio :
                                    <Moment
                                        date={DateStart}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateStart}
                                    onDidDismiss={() =>
                                        this.setState({
                                            isOpenDateStart: false,
                                            pages: 0,
                                            pageSize: 10,
                                        })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}
                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                <IonButton color='primary' expand="full" onClick={(e: any) => {
                                    e.persist();
                                    this.setState({ isOpenModalFilterDate: true });
                                }}>
                                    <IonIcon icon={funnel}></IonIcon>
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenModalFilterDate}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenModalFilterDate: false })}
                                >
                                    <IonList inset={true}>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                        >
                                            <IonLabel>Hoy</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                            <IonLabel>Ayer</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                            <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                            <IonLabel>Este Mes</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                            <IonLabel>Este Año</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                            <IonLabel>El Año Pasado</IonLabel>
                                        </IonItem>
                                    </IonList>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({ isOpenDateEnd: true });
                                    }}
                                >
                                    Fin :
                                    <Moment
                                        date={DateEnd}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateEnd}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenDateEnd: false })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}

                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-12 size='12' class='divflex'>
                                <IonIcon icon={search} className='iconseach'></IonIcon>
                                <DebounceInput
                                    className='btn_search'
                                    placeholder={'Código'}
                                    minLength={2}
                                    debounceTimeout={2000}
                                    value={searchText}
                                    onChange={e => this.setSearchText(e)} />
                            </IonCol>
                            <IonCol size='12'>
                                {data_render_data}
                            </IonCol>
                        </IonRow>
                    </IonContent >
                    <IonModal onDidDismiss={this.dismissModalUnits.bind(this)} isOpen={ModalShow} ref={this.ModalcreateEdit} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader>
                                <IonToolbar color="primary">
                                    <IonTitle>{fields && fields.id ? 'Editar Gasto' : 'Nuevo Gasto'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalUnits.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>
                            <IonRow>
                                <IonCol size='12' col-12>
                                    <label>Sucursal: </label>
                                    {
                                        data_default && data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeFields({ target: { name: 'location_id', value: e.value } })}
                                                placeholder="Ubicación"
                                                name='location_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={
                                                    data_default.businessLocations && data_default.businessLocations.map((option: any) => (
                                                        { label: option.name, value: option.id }
                                                    ))
                                                }
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={fields.location_id ?
                                                    data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                                        { label: data_default.businessLocations.filter((item: any) => item.id == fields.location_id)[0].name, value: data_default.businessLocations.filter((item: any) => item.id == fields.location_id)[0].id }
                                                        : { label: 'Seleccione', value: null }
                                                    : { label: 'Seleccione', value: null }
                                                }
                                            /> : null
                                    }
                                    {formErrors && formErrors.location_id && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.location_id}</small>
                                        </IonText>
                                    )}
                                </IonCol>
                                <IonCol size='6' col-6>
                                    <label>Categoria: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChangeFields({ target: { name: 'expense_category_id', value: e.value } })}
                                        placeholder="Categoria"
                                        name='expense_category_id'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: 'Seleccione', value: null },
                                            ...(categoriesDB && categoriesDB
                                                .filter((value: any) => value.parent_id == null)
                                                .map((value: any) => ({ label: value.name, value: value.id }))
                                            )
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={fields.expense_category_id ?
                                            categoriesDB && categoriesDB.length > 0 ?
                                                {
                                                    label: categoriesDB.filter((item: any) => item.id == fields.expense_category_id)[0].name, value: categoriesDB.filter((item: any) => item.id == fields.expense_category_id)[0].id
                                                }
                                                : { label: 'Seleccione', value: null }
                                            : { label: 'Seleccione', value: null }
                                        }
                                    />
                                </IonCol>
                                <IonCol size='6' col-6>
                                    <label>Sub-Categoria: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChangeFields({ target: { name: 'expense_sub_category_id', value: e.value } })}
                                        placeholder="Categoria"
                                        name='expense_sub_category_id'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: 'Seleccione', value: null },
                                            ...(slcategoriessub_selected && slcategoriessub_selected.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            )))
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={fields.expense_sub_category_id ?
                                            slcategoriessub_selected && slcategoriessub_selected.length > 0 ?
                                                {
                                                    label: slcategoriessub_selected.filter((item: any) => item.id == fields.expense_sub_category_id)[0].name, value: slcategoriessub_selected.filter((item: any) => item.id == fields.expense_sub_category_id)[0].id
                                                }
                                                : { label: 'Seleccione', value: null }
                                            : { label: 'Seleccione', value: null }
                                        }
                                    />
                                </IonCol>
                                <IonCol size='12' col-12>
                                    <IonButton
                                        expand="full"
                                        onClick={(e: any) => {
                                            e.persist();
                                            this.setState({ isOpenTransactionDate: true });
                                        }}
                                    >
                                        Fecha de la Venta :
                                        <Moment
                                            date={fields && fields.transaction_date}
                                            format="DD-MM-YYYY"
                                        />
                                    </IonButton>
                                    <IonPopover
                                        isOpen={isOpenTransactionDate}
                                        onDidDismiss={() => this.setState({ isOpenTransactionDate: false })}
                                    >
                                        <IonDatetime
                                            presentation="date"
                                            value={moment(fields && fields.transaction_date, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                            onIonChange={(e: any) => {
                                                this.setState({ isOpenTransactionDate: false });
                                                let date_selected = e.detail.value;
                                                console.log('date_selected', date_selected);
                                                this.handleChangeFields({ target: { name: 'transaction_date', value: date_selected } });
                                            }}

                                        ></IonDatetime>
                                    </IonPopover>
                                </IonCol>
                                <IonCol size='6' col-6>
                                    <label>Gastado Por: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChangeFields({ target: { name: 'expense_for', value: e.value } })}
                                        placeholder="Categoria"
                                        name='expense_for'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: 'Seleccione', value: null },
                                            ...(usersDB && usersDB.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            )))
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={fields.expense_for ?
                                            usersDB && usersDB.length > 0 ?
                                                {
                                                    label: usersDB.filter((item: any) => item.id == fields.expense_for)[0].name, value: usersDB.filter((item: any) => item.id == fields.expense_for)[0].id
                                                }
                                                : { label: 'Seleccione', value: null }
                                            : { label: 'Seleccione', value: null }
                                        }
                                    />
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <label>Monto: </label>
                                    <input
                                        autoComplete="off"
                                        onFocus={this.handleFocus}
                                        type="number"
                                        className='inputform input_quantity style_input'
                                        defaultValue={_numberFormat.format(parseFloat((fields && fields.final_total) ?? 0)).replace("$", "")}
                                        min="0"
                                        onChange={e => this.handleChangeFields({ target: { name: 'final_total', value: e.target.value } })}
                                        name="final_total" />
                                    {formErrors && formErrors.final_total && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.final_total}</small>
                                        </IonText>
                                    )}
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Nota: </label>
                                    <textarea className='inputform' rows={3} placeholder="Nota" onChange={this.handleChangeFields.bind(this)} value={(fields && fields.additional_notes) ?? ""}
                                        name="additional_notes" />
                                </IonCol>
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModalUnits()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModal(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonPage >
            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ExpenseActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ExpenseActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ExpenseActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(listGastos);
